import React from 'react'
import Helmet from 'react-helmet'
import Page from '../components/Page'
import PageHeader from '../components/PageHeader'
import { Container, Section } from '../components/common'
import Content from '../components/Content'

export default ({ title, data }) => {
  const image = data.image
  return (
    <Page>
      <PageHeader title={title} image={image} />
      <Section thin>
        <Container>
          <Content source={data.content} />
        </Container>
      </Section>
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./src/views/Default.js